import { render, staticRenderFns } from "./fdInventory54.vue?vue&type=template&id=7b6abe61"
import script from "./fdInventory54.vue?vue&type=script&lang=js"
export * from "./fdInventory54.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports